// helper functions
export const getPiece = (pieces, id) => pieces.find((piece) => piece.id === id);

// see if it current position is between 0 and 11
export const isInPlayingArea = (position) => position >= 0 && position <= 11;

// get the next possible move for a piece. Returns an INTEGER
export const getNextMove = (piece) => {
  const { currentPos, moveSet } = piece;
  return moveSet[(moveSet.indexOf(currentPos) + 1) % moveSet.length];
};
